// Global ApexCharts defaults for the site-wide dark theme.
// ApexCharts merges window.Apex into every chart's options; per-chart options
// still win, so controllers only need to avoid hardcoding light colors.
// Palette: #030303 base / #141414 surface / #434343 line / #9c9c9c muted /
// #c7c7c7 text / #f0f0f0 bright.
window.Apex = {
  chart: {
    background: "transparent",
    foreColor: "#c7c7c7" // axis labels, legend, title text
  },
  grid: {
    borderColor: "#434343"
  },
  tooltip: {
    theme: "dark"
  },
  xaxis: {
    axisBorder: { color: "#434343" },
    axisTicks: { color: "#434343" }
  },
  legend: {
    labels: { colors: "#c7c7c7" }
  },
  dataLabels: {
    style: { colors: ["#f0f0f0"] }
  }
}
